import * as yup from 'yup';

import { FORM_KEYS } from './constants';

const baseSchema = FORM_KEYS.reduce((acc, key) => {
  acc[key] = yup.string();
  return acc;
}, {});

export default yup.object({
  ...baseSchema,
  vin: yup.string().length(17).required(),
});
